import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '../App'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: App,
    redirect: 'login',
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login/index.vue')
      },
      {
        path: '/todo',
        name: 'todo',
        component: () => import('@/views/Todo/index.vue')
      },
      {
        path: '/bargainApproval',
        name: 'bargainApproval',
        component: () => import('@/views/BargainApproval/index.vue')
      },
      {
        path: '/accountOrderApproval',
        name: 'accountOrderApproval',
        component: () => import('@/views/AccountOrderApproval/index')
      },
      {
        path: '/payApproval',
        name: 'payApproval',
        component: () => import('@/views/PayApproval/index')
      },
      {
        path: '/poApproval',
        name: 'poApproval',
        component: () => import('@/views/PoApproval/index')
      },
      {
        path: '/pomApproval',
        name: 'pomApproval',
        component: () => import('@/views/PomApproval/index')
      },
      {
        path: '/prApproval',
        name: 'prApproval',
        component: () => import('@/views/PrApproval/index')
      },
      {
        path: '/cotApproval',
        name: 'cotApproval',
        component: () => import('@/views/CotApproval/index')
      },
      {
        path: '/supplierApplyApproval',
        name: 'supplierApplyApproval',
        component: () => import('@/views/SupplierApplyApproval/index')
      },
      {
        path: '/supplierResultApproval',
        name: 'supplierResultApproval',
        component: () => import('@/views/SupplierResultApproval/index')
      },
      {
        path: '/receiptStateChangeApproval',
        name: 'receiptStateChangeApproval',
        component: () => import('@/views/ReceiptStateChangeApproval/index')
      },
      {
        path: '/qualifyApplyApproval',
        name: 'qualifyApplyApproval',
        component: () => import('@/views/QualifyApproval/index')
      },
      {
        path: '/generalApplyApproval',
        name: 'generalApplyApproval',
        component: () => import('@/views/GeneralApproval/index')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
